import { useAppStore } from '../store/useAppStore';
import { ILoadingService } from './ILoadingService';
import { LoadingServiceImpl } from './LoadingServiceImpl';

export class LoadingServiceFactory {
  private static instance: LoadingServiceFactory | null = null;
  private appStore: typeof useAppStore;

  public static initialize(appStore: typeof useAppStore): void {
    LoadingServiceFactory.instance = new LoadingServiceFactory(appStore);
  }

  public static getInstance(): LoadingServiceFactory {
    if (LoadingServiceFactory.instance === null) {
      throw new Error(
        'LoadingServiceFactory not yet initialized. Call LoadingServiceFactory.initialize() first.',
      );
    }

    return LoadingServiceFactory.instance;
  }

  private constructor(appStore: typeof useAppStore) {
    this.appStore = appStore;
  }

  public createLoadingService(): ILoadingService {
    return new LoadingServiceImpl(this.appStore);
  }
}
